<template>
	<!-- info card start -->
    <div class="card">
        <div class="card-header">
            <h5 class="card-header-text">CBT Scores</h5>
            <a target="_blank" v-bind:href="'/opening/' + $parent.applicant.joblistings.id + '/application/' + $parent.applicant.id" class="btn btn-sm btn-primary waves-effect waves-light f-right">
                View CBT
            </a>
        </div>
        <div class="card-block">
        	
        	<div class="row">
                <div class="col-md-8">
                    <div class="card b-l-success business-info services m-b-20">
                        <div class="card-header">
                            <div class="service-header">
                                <h5 class="card-header-text">Test Scores</h5>
                            </div>
                        </div>
                        <div class="card-block">
                            <div class="row">
                                <div class="col-sm-12">
	                            	<div class="table-responsive" v-if="$parent.question_total_score">
	                            		<table class="table">
	                            			<tbody>
	                            				<tr>
	                            					<td>Applicant Total Score</td>
	                            					<td>{{$parent.applicant_total_score}}</td>
	                            				</tr>
	                            				<tr>
	                            					<td>Question Max Score</td>
	                            					<td>{{$parent.question_total_score}}</td>
	                            				</tr>
	                            				<tr>
	                            					<td>Applicant Score Percentage</td>
	                            					<td>{{$parent.score_percent}}</td>
	                            				</tr>
	                            			</tbody>
	                            		</table>
	                            	</div>
	                            	<div v-else>
	                            		<h5>This applicant has not completed a CBT exercise.</h5>
	                            	</div>
	                            </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<style type="text/css" soped>
	tr td:nth-child(1){
		font-weight: bold;
	}
</style>
<script type="text/javascript">
	export default{
		name: 'CBTScores',
		data(){
			return{
				
			}
		},
		methods: {

			init: function(){
				
			},
		},
		mounted(){
			this.init()
		}
	}
</script>